var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "id-finder-container" },
    [
      _c("div", { staticClass: "site-id-header" }, [
        _c(
          "div",
          { staticClass: "search-section" },
          [
            _c("a-input-search", {
              staticClass: "search-input",
              attrs: {
                placeholder: "ID veya isim ile arama yapın",
                enterButton: "",
                allowClear: "",
              },
              on: { search: _vm.handleSearch },
              model: {
                value: _vm.searchQuery,
                callback: function ($$v) {
                  _vm.searchQuery = $$v
                },
                expression: "searchQuery",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "site-id-container" }, [
          _c("span", { staticClass: "site-id-label" }, [
            _vm._v(_vm._s(_vm.$t("auto.iDFinderSiteId"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "site-id-value",
              on: {
                click: function ($event) {
                  return _vm.copyToClipboard(_vm.$store.state.site.site._id)
                },
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$store.state.site.site._id) +
                  "\n                "
              ),
              _c("a-icon", { attrs: { type: "copy" } }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "id-finder-content" }, [
        _c("div", { staticClass: "sidebar-menu" }, [
          _c("div", { staticClass: "menu-items" }, [
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "users" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("users")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#1890ff" },
                  },
                  [_vm._v("people")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.iDFinderUsers")))]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "tags" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("tags")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#52c41a" },
                  },
                  [_vm._v("local_offer")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.iDFinderEtiketler")))]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "tasktags" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("tasktags")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#fe6244" },
                  },
                  [_vm._v("local_offer")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("auto.iDFinderTaskEtiketleri"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "departments" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("departments")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#722ed1" },
                  },
                  [_vm._v("business")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("auto.iDFinderDepartmanlar"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "workflows" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("workflows")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#fa8c16" },
                  },
                  [_vm._v("assignment")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("auto.iDFinderTaskWorkflows"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "pipelines" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("pipelines")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#13c2c2" },
                  },
                  [_vm._v("view_column")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("auto.iDFinderPipelineStages"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "automations" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("automations")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#eb2f96" },
                  },
                  [_vm._v("smart_toy")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("auto.iDFinderOtomasyonlar"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "chatbots" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("chatbots")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#f5222d" },
                  },
                  [_vm._v("chat")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("auto.iDFinderChatbotScenarios"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "channels" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("channels")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#1890ff" },
                  },
                  [_vm._v("settings_input_component")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.iDFinderKanallar")))]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "whatsapp" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("whatsapp")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#52c41a" },
                  },
                  [_vm._v("message")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("auto.iDFinderWhatsAppTemplates"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "voiceAgents" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("voiceAgents")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#faad14" },
                  },
                  [_vm._v("record_voice_over")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("auto.iDFinderVoiceAgents"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "form" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("form")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#9932cc" },
                  },
                  [_vm._v(" assignment ")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.iDFinderForm")))]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "calendar" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("calendar")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#00b894" },
                  },
                  [_vm._v(" calendar_today ")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.iDFinderTakvim")))]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "tables" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("tables")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#ff6b6b" },
                  },
                  [_vm._v(" table_chart ")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.iDFinderTablolar")))]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "table-fields" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("table-fields")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#4ecdc4" },
                  },
                  [_vm._v(" view_column ")]
                ),
                _vm._v(" "),
                _c("span", [
                  _vm._v(_vm._s(_vm.$t("auto.iDFinderTableFields"))),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "modules" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("modules")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#95e1d3" },
                  },
                  [_vm._v(" view_module ")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.iDFinderModules")))]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "menu-item",
                class: { active: _vm.activeTab === "languages" },
                on: {
                  click: function ($event) {
                    return _vm.handleTabChange("languages")
                  },
                },
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "material-icons menu-icon",
                    staticStyle: { color: "#2f54eb" },
                  },
                  [_vm._v(" language ")]
                ),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(_vm.$t("auto.iDFinderLanguages")))]),
              ]
            ),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-area" }, [
          _c("div", { staticClass: "tab-content" }, [
            _vm.activeTab === "users"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.userColumns,
                        "data-source": _vm.filteredUsers,
                        loading: _vm.loading.users,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("auto.iDFinderKopyala")) +
                                        "\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3868099041
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "tags"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.tagColumns,
                        "data-source": _vm.filteredTags,
                        loading: _vm.loading.tags,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "color",
                            fn: function (color) {
                              return [
                                _c("div", {
                                  staticClass: "color-indicator",
                                  style: { backgroundColor: color },
                                }),
                              ]
                            },
                          },
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      " Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1006320208
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "tasktags"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.tagColumns,
                        "data-source": _vm.filteredTags,
                        loading: _vm.loading.tags,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "color",
                            fn: function (color) {
                              return [
                                _c("div", {
                                  staticClass: "color-indicator",
                                  style: { backgroundColor: color },
                                }),
                              ]
                            },
                          },
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      "\n                                Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3749463394
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "departments"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.departmentColumns,
                        "data-source": _vm.filteredDepartments,
                        loading: _vm.loading.departments,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "name",
                            fn: function (text, record) {
                              return [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.getDepartmentName(record)) +
                                    "\n                        "
                                ),
                              ]
                            },
                          },
                          {
                            key: "status",
                            fn: function (status) {
                              return [
                                _c("a-badge", {
                                  attrs: {
                                    status: status ? "success" : "error",
                                    text: status ? "Aktif" : "Pasif",
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      " Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        4226746436
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "workflows"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.workflowColumns,
                        "data-source": _vm.filteredWorkflows,
                        loading: _vm.loading.workflows,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      " Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3017468963
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "pipelines"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.pipelineColumns,
                        "data-source": _vm.filteredPipelines,
                        loading: _vm.loading.pipelines,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "color",
                            fn: function (color) {
                              return [
                                _c("div", {
                                  staticClass: "color-indicator",
                                  style: {
                                    backgroundColor: color || "#cccccc",
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      " Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        78653267
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "automations"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.automationColumns,
                        "data-source": _vm.filteredAutomations,
                        loading: _vm.loading.automations,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "trigger",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-tag",
                                  {
                                    attrs: {
                                      color: _vm.getAutomationTriggerColor(
                                        _vm.$_.get(record.options, "trigger")
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(
                                          _vm.getAutomationTriggerText(
                                            _vm.$_.get(
                                              record.options,
                                              "trigger"
                                            )
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "published",
                            fn: function (published) {
                              return [
                                _c("a-badge", {
                                  attrs: {
                                    status: published ? "success" : "error",
                                    text: published
                                      ? "Yayında"
                                      : "Yayında Değil",
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      " Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2301459069
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "chatbots"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.chatbotColumns,
                        "data-source": _vm.filteredChatbots,
                        loading: _vm.loading.chatbots,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "integrations",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "div",
                                  { staticClass: "integration-tags" },
                                  [
                                    _vm.$_.get(
                                      record.integrations,
                                      "supsisWidget"
                                    )
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "blue" } },
                                          [_vm._v("Widget")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$_.get(record.integrations, "whatsapp")
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "green" } },
                                          [_vm._v("WhatsApp")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$_.get(
                                      record.integrations,
                                      "whatsappBusiness"
                                    )
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "green" } },
                                          [_vm._v("WhatsApp Business")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$_.get(record.integrations, "instagram")
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "purple" } },
                                          [_vm._v("Instagram")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.$_.get(record.integrations, "telegram")
                                      ? _c(
                                          "a-tag",
                                          { attrs: { color: "#0088cc" } },
                                          [_vm._v("Telegram")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      " Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1235452292
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "channels"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.channelColumns,
                        "data-source": _vm.filteredChannels,
                        loading: _vm.loading.channels,
                        pagination: { pageSize: 30 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "channelType",
                            fn: function (text, record) {
                              return [
                                _c("span", [_vm._v(_vm._s(record.type))]),
                                _vm._v(" "),
                                record.type === "openrouter" &&
                                _vm.$_.get(record, "payload.provider")
                                  ? _c(
                                      "a-tag",
                                      {
                                        staticStyle: { "margin-left": "5px" },
                                        attrs: { color: "purple" },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(
                                              _vm.getOpenRouterProviderName(
                                                _vm.$_.get(
                                                  record,
                                                  "payload.provider"
                                                )
                                              )
                                            ) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                          {
                            key: "channelAction",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      " Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                record.type === "openrouter"
                                  ? _c(
                                      "a-button",
                                      {
                                        staticStyle: { "margin-left": "8px" },
                                        attrs: {
                                          type: "default",
                                          size: "small",
                                          loading:
                                            _vm.loadingModelsChannelId ===
                                            record._id,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openOpenRouterModelsModal(
                                              record
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c("a-icon", {
                                          attrs: { type: "unordered-list" },
                                        }),
                                        _vm._v(
                                          " Modeller\n                            "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        905184492
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "whatsapp"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "whatsapp-filter" },
                      [
                        _c(
                          "a-select",
                          {
                            staticClass: "channel-select",
                            attrs: {
                              placeholder: "Whatsapp Business API kanalı seçin",
                            },
                            on: { change: _vm.loadWhatsappTemplates },
                            model: {
                              value: _vm.selectedChannel,
                              callback: function ($$v) {
                                _vm.selectedChannel = $$v
                              },
                              expression: "selectedChannel",
                            },
                          },
                          _vm._l(_vm.whatsappChannels, function (channel) {
                            return _c(
                              "a-select-option",
                              {
                                key: channel._id,
                                attrs: { value: channel._id },
                              },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(channel.name) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("a-table", {
                      attrs: {
                        columns: _vm.whatsappColumns,
                        "data-source": _vm.filteredWhatsappTemplates,
                        loading: _vm.loading.whatsapp,
                        pagination: { pageSize: 30 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "whatsappName",
                            fn: function (text, record) {
                              return [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getFormattedWhatsappTemplate(record)
                                        .name
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            },
                          },
                          {
                            key: "whatsappLanguage",
                            fn: function (text, record) {
                              return [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getFormattedWhatsappTemplate(record)
                                        .language
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            },
                          },
                          {
                            key: "status",
                            fn: function (status) {
                              return [
                                _c("a-badge", {
                                  attrs: {
                                    status: _vm.getStatusType(status),
                                    text: _vm.getStatusText(status),
                                  },
                                }),
                              ]
                            },
                          },
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record.id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      " Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        481101486
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "voiceAgents"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.voiceAgentColumns,
                        "data-source": _vm.filteredVoiceAgents,
                        loading: _vm.loading.voiceAgents,
                        pagination: { pageSize: 30 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "agent_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "type",
                            fn: function (text, record) {
                              return [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(_vm.getVoiceAgentType(record)) +
                                    "\n                        "
                                ),
                              ]
                            },
                          },
                          {
                            key: "agentType",
                            fn: function (text, record) {
                              return [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(
                                      _vm.getVoiceAgentPromptType(record)
                                    ) +
                                    "\n                        "
                                ),
                              ]
                            },
                          },
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(
                                          record.agent_id
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      " Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3762285671
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "form"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.formColumns,
                        "data-source": _vm.filteredForms,
                        loading: _vm.loading.forms,
                        pagination: { pageSize: 30 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      "\n                                Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2437997457
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "calendar"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.calendarColumns,
                        "data-source": _vm.filteredCalendars,
                        loading: _vm.loading.calendars,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "color",
                            fn: function (color) {
                              return [
                                _c("div", {
                                  staticClass: "color-indicator",
                                  style: { backgroundColor: color },
                                }),
                              ]
                            },
                          },
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      "\n                                Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3749463394
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "tables"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.tableColumns,
                        "data-source": _vm.filteredTables,
                        loading: _vm.loading.tables,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      "\n                                Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2437997457
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "table-fields"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c(
                      "div",
                      { staticClass: "table-field-filter" },
                      [
                        _c(
                          "a-select",
                          {
                            staticClass: "table-select",
                            attrs: {
                              placeholder: "Tablo seçin",
                              "show-search": "",
                              "filter-option": _vm.filterTableOption,
                            },
                            on: { change: _vm.handleTableChange },
                            model: {
                              value: _vm.selectedTable,
                              callback: function ($$v) {
                                _vm.selectedTable = $$v
                              },
                              expression: "selectedTable",
                            },
                          },
                          _vm._l(_vm.tables, function (table) {
                            return _c(
                              "a-select-option",
                              { key: table._id, attrs: { value: table._id } },
                              [
                                _vm._v(
                                  "\n                                " +
                                    _vm._s(table.name) +
                                    "\n                            "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("a-table", {
                      attrs: {
                        columns: _vm.tableFieldColumns,
                        "data-source": _vm.filteredTableFields,
                        loading: _vm.loading.tableFields,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      "\n                                Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2437997457
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "modules"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.moduleColumns,
                        "data-source": _vm.filteredModules,
                        loading: _vm.loading.modules,
                        pagination: { pageSize: 10 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "_id",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "action",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record._id)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      "\n                                Kopyala\n                            "
                                    ),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                record.type === "module"
                                  ? _c(
                                      "a-button",
                                      {
                                        staticStyle: { "margin-left": "8px" },
                                        attrs: {
                                          type: "default",
                                          size: "small",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.openModuleApiDoc(record)
                                          },
                                        },
                                      },
                                      [
                                        _c("a-icon", {
                                          attrs: { type: "file-text" },
                                        }),
                                        _vm._v(
                                          "\n                                API Doc\n                            "
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3042546968
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.activeTab === "languages"
              ? _c(
                  "div",
                  { staticClass: "table-container" },
                  [
                    _c("a-table", {
                      attrs: {
                        columns: _vm.languageColumns,
                        "data-source": _vm.filteredLanguages,
                        pagination: { pageSize: 15 },
                        scroll: { y: _vm.tableHeight },
                        size: "middle",
                        "row-key": "code",
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "langAction",
                            fn: function (text, record) {
                              return [
                                _c(
                                  "a-button",
                                  {
                                    attrs: { type: "primary", size: "small" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.copyToClipboard(record.code)
                                      },
                                    },
                                  },
                                  [
                                    _c("a-icon", { attrs: { type: "copy" } }),
                                    _vm._v(
                                      "\n                                " +
                                        _vm._s(_vm.$t("auto.iDFinderKopyala")) +
                                        "\n                            "
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        1504816648
                      ),
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            title: _vm.openRouterModelsChannel
              ? _vm.openRouterModelsChannel.name + " - Model Listesi"
              : "Model Listesi",
            width: "900px",
            footer: null,
          },
          model: {
            value: _vm.openRouterModelsModal,
            callback: function ($$v) {
              _vm.openRouterModelsModal = $$v
            },
            expression: "openRouterModelsModal",
          },
        },
        [
          _c(
            "div",
            { staticClass: "openrouter-models-modal" },
            [
              _vm.openRouterModelsChannel
                ? _c(
                    "div",
                    { staticClass: "models-info" },
                    [
                      _c("a-tag", { attrs: { color: "purple" } }, [
                        _vm._v(
                          "\n                    " +
                            _vm._s(
                              _vm.getOpenRouterProviderName(
                                _vm.$_.get(
                                  _vm.openRouterModelsChannel,
                                  "payload.provider",
                                  "openrouter"
                                )
                              )
                            ) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "models-count" }, [
                        _vm._v(
                          _vm._s(_vm.openRouterModels.length) + " model bulundu"
                        ),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("a-table", {
                attrs: {
                  columns: [
                    {
                      title: "Model ID",
                      dataIndex: "id",
                      key: "id",
                      width: "300px",
                      ellipsis: true,
                    },
                    {
                      title: "İsim",
                      dataIndex: "name",
                      key: "name",
                      ellipsis: true,
                    },
                    {
                      title: "Context",
                      dataIndex: "context_length",
                      key: "context_length",
                      width: "100px",
                    },
                    {
                      title: "İşlem",
                      key: "action",
                      scopedSlots: { customRender: "modelAction" },
                      width: "100px",
                    },
                  ],
                  "data-source": _vm.openRouterModels,
                  pagination: { pageSize: 10 },
                  scroll: { y: 400 },
                  size: "small",
                  "row-key": "id",
                },
                scopedSlots: _vm._u([
                  {
                    key: "modelAction",
                    fn: function (text, record) {
                      return [
                        _c(
                          "a-button",
                          {
                            attrs: { type: "primary", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.copyModelId(record.id)
                              },
                            },
                          },
                          [_c("a-icon", { attrs: { type: "copy" } })],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }